import styled, { css } from 'styled-components';

import { GridColSt } from 'app/dealer/shared/components/Grid/Grid.css';

import { color, media, zIndex } from '../../styles_js/variables';

const commonStyles = css`
  color: #fff;
  font-weight: 100;
`;

export const FooterSt = styled.footer`
  position: relative;
  z-index: ${zIndex.footer}; /* Here to make the sticky block in the PDP hide behind this */
  background-color: ${color.brandSecondary};
  ${commonStyles};
  padding-top: 64px;
  padding-bottom: 104px;

  ${media.md(css`
    padding-bottom: 64px;
  `)};
  ${media.xl(css`
    padding-bottom: 48px;
  `)};
`;

export const FooterListColSt = styled(GridColSt)`
  display: flex;
  flex-direction: column;

  &:first-child {
    margin-bottom: 40px;
  }

  ${media.md(css`
    &:first-child {
      margin-bottom: 0px;
    }
  `)};

  & > a {
    ${commonStyles};
    line-height: 2;
    font-size: 16px;

    :hover {
      font-weight: unset;
      text-decoration: none;
    }
  }
`;

export const FooterCopySt = styled(GridColSt)`
  font-size: 12px;
  line-height: 2;
  margin-top: 64px;

  ${media.md(css`
    margin-top: 120px;
  `)};
  ${media.xl(css`
    margin-top: 104px;
  `)};
`;
